import React, { useEffect, useRef } from "react";

/**
 * An <input>-like element that grows vertically as the user types longer
 * text. Backed by a <textarea> with rows={1} that auto-sizes on each
 * change. Mirrors the props of a normal input for drop-in replacement.
 *
 *   <AutoGrowInput
 *     defaultValue={t.title}
 *     onBlur={...}
 *     className="hud-input ..."
 *     placeholder="Task…"
 *   />
 */
const AutoGrowInput = React.forwardRef(function AutoGrowInput(props, ref) {
  const internalRef = useRef(null);
  const taRef = ref || internalRef;

  const resize = () => {
    const el = taRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => {
    resize();
    // Re-measure when the parent layout changes (e.g. column resize)
    const ro = new ResizeObserver(() => resize());
    if (taRef.current) ro.observe(taRef.current);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <textarea
      ref={taRef}
      rows={1}
      onInput={resize}
      style={{
        resize: "none",
        overflow: "hidden",
        lineHeight: "1.35",
        ...(props.style || {}),
      }}
      {...props}
    />
  );
});

export default AutoGrowInput;
